<!-- listing and total no.of counts -->
<div class="row">

</div>

<div class="card-container">
  <div class="col-12 col-sm-4 col-lg-4 m-t-16">
    <input type="text" placeholder="Search" aria-label="Number" id="search"  class="form-control" (keyup)="applyFilter($event.target['value'])" >
  </div>

  <!-- write code for text input field to search -->
  <div class="row">
    <div class="col-12 col-sm-4 col-lg-4  m-t-16" *ngFor="let ov of overview$ | async;  let i = index ">
      <mat-card (click)="onKantineOverviewClick(ov.companyId,ov.siteId,ov.systemId)" class="cardWithShadow"
        [ngClass]="statusColor(ov.kantineAvailble)">
        <mat-card-header class="">
          <mat-card-title-group>
            <mat-card-title (click)="gotoSystem($event,ov.companyId,ov.siteId,ov.systemId)"> {{ov.systemName}} -
              {{ov.updatedOn}}</mat-card-title>
            <div *ngIf="ov.issues.length>0" class="m-l-auto">
              <button mat-fab color="warn" class="shadow-none icon-48">
                {{ov.issues.length}}
              </button>
            </div>
          </mat-card-title-group>
        </mat-card-header>
        <mat-card-content>
          <div class="row m-t-16">
            <div class="col-12">
              <div class="align-items-center m-t-8">
                <!-- machine card starts -->
                <div class="row">
                  <div class="col-lg-4 col-sm-4 col-4" *ngFor="let maskin of ov.machineDataBymapping | keyvalue">
                    <mat-card class="cardWithShadow">
                      <mat-card-content class="p-t-6">
                        <mat-card-subtitle class="mat-body-1 p-b-2">{{maskin.value['name']}}</mat-card-subtitle>
                        <h6 class="p-b-2">{{maskin.value['machineDoorStatus']}}</h6>
                        <div class="d-flex align-items-center m-t-16">
                          <mat-icon class="bg-light-success text-success shadow-none icon-20">device_thermostat</mat-icon>
                          <div class="f-w-600 m-l-12"> {{maskin.value['machineTempStatus']}}</div>
                        </div>
                        <div class="d-flex align-items-center justify-content-between m-t-30">
                          <div class="d-flex align-items-center" (click)="resetMachine($event,maskin.value)">
                            <span
                              class="text-primary bg-light-primary rounded icon-40 d-flex align-items-center justify-content-center">
                              <mat-icon class="icon-20 d-flex">autorenew</mat-icon>
                            </span>
                          </div>
                          <div class="d-flex align-items-center" (click)="collectProduct($event,maskin.value)">
                            <span
                              class="text-accent bg-light-accent rounded icon-40 d-flex align-items-center justify-content-center">
                              <mat-icon class="icon-20 d-flex">badge</mat-icon>
                            </span>
                          </div>
                        </div>
                      </mat-card-content>
                    </mat-card>
                  </div>
                </div>
                <!-- machine card end -->
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
